import React from 'react';
import { Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import CompanyInfoPage from 'pages/dashboard/company-info/CompanyInfo';
import DeliveryNoteListPage from 'pages/dashboard/delivery-note-list/DeliveryNoteList';
import { InboundListPage } from 'pages/dashboard/inbound-list/InboundList';
import InventoryAdjustmentListPage from 'pages/dashboard/inventory-adjustment-list/InventoryAdjustmentList';
import MasterBinPage from 'pages/dashboard/master-bin/MasterBin';
import OrderListPage from 'pages/dashboard/order-lists/OrderList';
import PharmacyUploadPage from 'pages/dashboard/pharmacy-upload/PharmacyUpload';
import ProductUploadPage from 'pages/dashboard/product-upload/ProductUpload';
import ReplenishListPage from 'pages/dashboard/replenish-list/ReplenishList';
import STOListPage from 'pages/dashboard/sto-list/STOList';
import StockTransferListPage from 'pages/dashboard/stock-transfer-list/StockTransferList';
import SummariesPage from 'pages/dashboard/summaries/Summaries';
import UserListPage from 'pages/dashboard/user-list/UserList';
import UserUploadPage from 'pages/dashboard/user-upload/UserUpload';

import {
  DASHBOARD_ROUTE_ROOT,
  DASHBOARD_ROUTES,
} from './constants/dashboard-routes.constant';

export const useDashboardRouter = (): React.JSX.Element => (
  <>
    <Route
      path={DASHBOARD_ROUTE_ROOT}
      element={
        <PrivateRoute
          roles={[
            UserRolesEnum.ADMIN,
            UserRolesEnum.SUPER_ADMIN,
            UserRolesEnum.PICKER_LEAD,
          ]}
        />
      }
    >
      <Route path={DASHBOARD_ROUTES.SUMMARY} element={<SummariesPage />} />
      <Route path={DASHBOARD_ROUTES.ORDER_ITEM} element={<OrderListPage />} />
      <Route path={DASHBOARD_ROUTES.USERS} element={<UserListPage />} />
      <Route
        path={DASHBOARD_ROUTES.REPLENISH_ITEM}
        element={<ReplenishListPage />}
      />
      <Route
        path={DASHBOARD_ROUTES.STOCK_TRANSFER_ITEM}
        element={<StockTransferListPage />}
      />
      <Route
        path={DASHBOARD_ROUTES.PRODUCT_UPLOAD}
        element={<ProductUploadPage />}
      />
      <Route path={DASHBOARD_ROUTES.BINS} element={<MasterBinPage />} />
      <Route path={DASHBOARD_ROUTES.STO} element={<STOListPage />} />
      <Route path={DASHBOARD_ROUTES.INBOUND} element={<InboundListPage />} />
      <Route
        path={DASHBOARD_ROUTES.DELIVERY_NOTE}
        element={<DeliveryNoteListPage />}
      />
    </Route>
    <Route
      path={DASHBOARD_ROUTE_ROOT}
      element={<PrivateRoute roles={[UserRolesEnum.SUPER_ADMIN]} />}
    >
      <Route path={DASHBOARD_ROUTES.USER_UPLOAD} element={<UserUploadPage />} />
      <Route
        path={DASHBOARD_ROUTES.PHARMACY_UPLOAD}
        element={<PharmacyUploadPage />}
      />
      <Route
        path={DASHBOARD_ROUTES.COMPANY_INFO}
        element={<CompanyInfoPage />}
      />
      <Route
        path={DASHBOARD_ROUTES.INVENTORY_ADJUSTMENT}
        element={<InventoryAdjustmentListPage />}
      />
    </Route>
  </>
);
